/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-contract
 * OpenAPI spec version: 1.0.0
 */

/**
 * The contract type
 */
export type ContractType = (typeof ContractType)[keyof typeof ContractType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractType = {
  distribution: "distribution",
  legacy_distribution: "legacy_distribution",
  neighbouring_rights: "neighbouring_rights",
} as const;
